import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Services from '../pages/services/page';
import Partners from '../pages/partners/page';
import TradeData from '../pages/trade-data/page';
import Contact from '../pages/contact/page';
import Gallery from '../pages/gallery/page';
import News from '../pages/news/page';
import NewsDetail from '../pages/news/detail/page';
import AdminLogin from '../pages/admin/LoginPage';
import AdminDashboard from '../pages/admin/page';

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/about', element: <About /> },
  { path: '/services', element: <Services /> },
  { path: '/partners', element: <Partners /> },
  { path: '/trade-data', element: <TradeData /> },
  { path: '/contact', element: <Contact /> },
  { path: '/gallery', element: <Gallery /> },
  { path: '/news', element: <News /> },
  { path: '/news/:slug', element: <NewsDetail /> },
  { path: '/admin/login', element: <AdminLogin /> },
  { path: '/admin', element: <AdminDashboard /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
